import { DocumentType } from '@dc-shared-web/hooks/api/office/types'
import { AxiosInstance } from 'axios'

export const fetchOfficeDocumentTypes = async (apiClient: AxiosInstance) => {
  const { data } = await apiClient.get<DocumentType[]>(
    `/api/office/document-types`
  )

  return data
}
